<template>
  <div>
    <div style="margin-bottom: 24px;">
      <div class="title hide-on-small-only">
        <h4>Clientes</h4>
        <div style="display: flex;">
          <a
            class="waves-effect waves-light btn"
            style="margin-right: 16px;"
            @click="openFilter = true"
          >
            <i class="material-icons">filter_alt</i>
          </a>
          <router-link
            v-show="checkModulePermission('customer', 'create')"
            tag="a"
            class="waves-effect waves-light btn"
            :to="{ name: 'customer-create' }"
          >
            <i class="material-icons">add</i>
          </router-link>
        </div>
      </div>
      <a
        class="hide-on-med-and-up btn-floating btn-large waves-effect waves-light"
        style="bottom: 88px;"
        @click="openFilter = true"
      >
        <i class="material-icons">filter_alt</i>
      </a>
      <router-link
        tag="a"
        v-show="checkModulePermission('customer', 'create')"
        class="hide-on-med-and-up btn-floating btn-large waves-effect waves-light"
        :to="{ name: 'customer-create' }"
      >
        <i class="material-icons">add</i>
      </router-link>
      <div class="hide-on-small-only">
        <table>
          <thead>
            <th width="70px"></th>
            <th>CNPJ</th>
            <th>Nome da Empresa</th>
            <th>Nome Fantasia</th>
            <th>Responsável</th>
            <th
              width="180px"
              v-show="checkModulePermission('customer', 'edit')"
            ></th>
          </thead>
          <tbody>
            <tr v-if="!customers.data.length > 0">
              <td colspan="6" class="center-align">
                {{
                  loadItens
                    ? "Buscando Clientes..."
                    : "Nenhum cliente cadastrado"
                }}
              </td>
            </tr>
            <tr v-else v-for="customer in customers.data" :key="customer.uuid">
              <td>
                <div class="icon">
                  <img :src="customer.logo" alt width="48" height="48" />
                </div>
              </td>
              <td>{{ customer.cnpj | cpf_cnpj }}</td>
              <td>{{ customer.company_name }}</td>
              <td>{{ customer.fancy_name }}</td>
              <td>{{ customer.contact }}</td>
              <td v-show="checkModulePermission('customer', 'edit')">
                <div id="has-button-disabled">
                  <router-link
                    class="waves-effect waves-light btn btn-icon"
                    tag="a"
                    :to="{
                      name: 'customer-edit',
                      params: { id: customer.uuid }
                    }"
                  >
                    <i class="material-icons">edit</i>
                  </router-link>
                  <disabled-item-button
                    :id="'disabled-' + customer.uuid"
                    @click="disabled(customer.uuid, customer.active == 1)"
                    :active="!!customer.active"
                  />
                  <hidden-item-button
                  :id="'hidden-' + customer.uuid"
                    @click="hidden(customer.uuid, customer.hidden == 1)"
                    :hidden="!!customer.hidden"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          v-if="customers.data"
          :total-pages="totalPages"
          @changePage="changePage"
          :current-page="currentPage"
        />
      </div>

      <div class="box-list hide-on-med-and-up">
        <ul class="collection">
          <li v-if="!customers.data.length > 0" class="white default-item">
            <p>
              {{
                loadItens ? "Buscando Clientes..." : "Nenhum cliente cadastrado"
              }}
            </p>
          </li>
          <li
            v-else
            class="collection-item avatar"
            style="align-items: center;"
            v-for="customer in customers.data"
            :key="customer.uuid"
          >
            <img
              :src="customer.logo"
              alt
              width="56"
              height="56"
              style="border-radius: 56px;margin-right: 16px;"
            />
            <div class="collection-item__text">
              <span class="title">{{ customer.company_name }}</span>
              <p>
                <b>CNPJ:</b>
                {{ customer.cnpj | cpf_cnpj }}
                <br />
                <b>Responsável:</b>
                {{ customer.contact }}
              </p>
            </div>
            <div
              class="collection-item__actions"
              style="align-self: flex-start;"
              v-show="checkModulePermission('customer', 'edit')"
            >
              <router-link
                class="waves-effect waves-light btn btn-icon"
                tag="a"
                :to="{ name: 'customer-edit', params: { id: customer.uuid } }"
              >
                <i class="material-icons">edit</i>
              </router-link>
              <disabled-item-button
                :id="'disabled-' + customer.uuid"
                @click="disabled(customer.uuid, customer.active == 1)"
                :active="!!customer.active"
              />
              <hidden-item-button
                :id="'hidden-' + customer.uuid"
                @click="hidden(customer.uuid, customer.hidden == 1)"
                :hidden="!!customer.hidden"
              />
            </div>
          </li>
          <li
            v-if="totalPages > 0 && currentPage !== totalPages"
            @click="changePage(currentPage + 1)"
            class="white default-item get-itens"
          >
            <feather v-if="loadItens" type="loader" animation="spin" />
            <p v-else>Buscar mais itens</p>
          </li>
        </ul>
      </div>
    </div>
    <VSideSlider
      :open="openFilter"
      @close="openFilter = false"
      title="Filtro de Clientes"
    >
      <div slot="body">
        <div class="row">
          <div class="input-field col s12">
            <label for="cnpj">CNPJ</label>
            <input type="text" name="cnpj" id="cnpj" v-model="filter.cnpj" />
          </div>
          <div class="input-field col s12">
            <label for="company_name">Nome da Empresa</label>
            <input
              type="text"
              name="company_name"
              id="company_name"
              v-model="filter.company_name"
            />
          </div>
          <div class="input-field col s12">
            <label for="fancy_name"> Nome Fantasia</label>
            <input
              type="text"
              name="fancy_name"
              id="fancy_name"
              v-model="filter.fancy_name"
            />
          </div>
        </div>
      </div>
      <div slot="actions">
        <div class="row">
          <div class="col s12 m6 s-mb-16">
            <button
              class="waves-effect btn-large flat form-button"
              @click="clearFilter"
            >
              Limpar
            </button>
          </div>
          <div class="col s12 m6">
            <button
              class="waves-effect waves-light btn-large form-button"
              @click="handleFilter"
              :class="{ load: loadFilter }"
            >
              <feather v-if="loadFilter" type="loader" animation="spin" />
              <template v-else
                >Filtrar</template
              >
            </button>
          </div>
        </div>
      </div>
    </VSideSlider>
  </div>
</template>

<script>
import { mapState } from "vuex";
import checkModulePermission from "@/services/mixins/checkModulePermission";

export default {
  name: "ListCustomer",
  mixins: [checkModulePermission],
  components: {
    VSideSlider: () => import("@/components/VSideSlider")
  },
  data: () => ({
    openFilter: false,
    loadItens: false,
    loadFilter: false,
    currentPage: 1,
    totalPages: 0,
    customers: {
      data: []
    },
    filter: {
      cnpj: "",
      fancy_name: "",
      company_name: ""
    }
  }),
  mounted() {
    this.getCustomers();
  },
  computed: {
    ...mapState("User", ["token"])
  },
  methods: {
    clearFilter() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = "";
        this.$el.querySelector(`label[for=${key}]`).classList.remove("active");
      });

      this.openFilter = false;
      this.getCustomers(1);
    },
    async handleFilter() {
      this.loadFilter = true;

      let query = Object.keys(this.filter).reduce((curr, keyFilter) => {
        if (this.filter[keyFilter]) {
          return (
            curr +
            `${keyFilter}:${
              keyFilter === "cnpj"
                ? this.filter[keyFilter].replace(/[^\d]+/g, "")
                : this.filter[keyFilter]
            };`
          );
        }

        return curr;
      }, "&search=");

      if (query != "&search=")
        await this.getCustomers(
          1,
          query.includes(";") ? query.substring(0, query.length - 1) : query
        );

      this.loadFilter = false;
      this.openFilter = false;
    },
    async getCustomers(page, query = "") {
      const pageSearch = page || this.currentPage;

      let url = `customers?page=${pageSearch}` + query;

      try {
        this.loadItens = true;
        const response = await this.$http.get(url, {
          headers: {
            Authorization: this.token
          }
        });
        this.loadItens = false;
        const { customers } = response.body.data;
        this.customers = customers;
        this.totalPages = customers.meta.total;
      } catch (e) {
        console.error(e);
      }
    },
    async changePage(payload) {
      await this.getCustomers(payload);
      this.currentPage = payload;
    },
    disabled(id, active) {
      this.$swal({
        title: "Tem certeza?",
        text: "Este item será desabilitado.",
        icon: "warning",
        buttons: {
          back: {
            text: "Cancelar"
          },
          confirm: {
            text: "Continuar",
            value: "ACTION",
            closeModal: false
          }
        }
      })
        .then(async v => {
          if (v === "ACTION") {
            try {
              await this.$http.post(
                `customers/${id}`,
                {
                  customer: {
                    active: active ? 0 : 1
                  }
                },
                {
                  headers: {
                    Authorization: `bearer ${this.token}`
                  }
                }
              );
              const el = document.getElementById('disabled-' + id);

              this.customers.data = this.customers.data.map(val => {
                if (val.uuid === id) {
                  return {
                    ...val,
                    active: active ? 0 : 1
                  };
                }

                return val;
              });

              if (active) el.classList.remove("active");
              else el.classList.add("active");

              this.$swal.stopLoading();
              this.$swal.close();
            } catch (e) {
              throw e;
            }
          }

          return null;
        })
        .catch(err => {
          if (err) {
            this.$swal(
              "Opss..",
              "Falha ao se comunicar com servidor, tente novamente mais tarde",
              "error"
            );
          } else {
            this.$swal.stopLoading();
            this.$swal.close();
          }
        });
    },
    hidden(id, hidden) {
      this.$swal({
        title: "Tem certeza?",
        text: "Este item será escondido permanentemente.",
        icon: "warning",
        buttons: {
          back: {
            text: "Cancelar"
          },
          confirm: {
            text: "Esconder",
            value: "ACTION",
            closeModal: false
          }
        }
      })
        .then(async v => {
          if (v === "ACTION") {
            try {
              await this.$http.post(
                `customers/${id}`,
                {
                  customer: {
                    hidden: 1,
                    active: 0,
                  }
                },
                {
                  headers: {
                    Authorization: `bearer ${this.token}`
                  }
                }
              );
              const el = document.getElementById('hidden-' + id);

              this.customers.data = this.customers.data.filter(val => !(val.uuid === id));

              if (hidden) el.classList.remove("active");
              else el.classList.add("active");

              this.$swal.stopLoading();
              this.$swal.close();
            } catch (e) {
              console.log(e)
              throw e;
            }
          }

          return null;
        })
        .catch(err => {
          if (err) {
            this.$swal(
              "Opss..",
              "Falha ao se comunicar com servidor, tente novamente mais tarde",
              "error"
            );
          } else {
            this.$swal.stopLoading();
            this.$swal.close();
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.form-button {
  width: 100%;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;

  @media #{$small-and-down} {
    padding: 16px 24px;
    a {
      height: 100%;
      width: 100%;
    }
  }
}
.box-list {
  padding: 0 16px;
}
.circle {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
@media #{$small-and-down} {
  .collection-item {
    .title {
      padding: 10px 0 !important;
    }
  }
}
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    border-radius: 48px;
  }
}
.default-item {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.get-itens {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}
</style>
<style lang="scss">
.swal-button--back {
  background-color: #e0e0e0;
  color: #000;
}
</style>
